import { InvitePage } from '../c/Game';
export default InvitePage;



// WEBPACK FOOTER //
// ./src/p/InvitePage.js